import Model from 'src/app/common/model';
import BusinessEntity from './businessEntity.model';

// work on this model
export default class PersonsModel extends Model {
  BusinessEntity: BusinessEntity;
  address: Array<IAddress>;
  farmLocations?: Array<IFarmLocations>;
  farmBusinesses?: Array<IFarmBusiness>;
  personType: Array<IPersonType>;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email?: string;
  businessID?: any;
  startDate?: Date;
  endDate?: Date;
  isActive: boolean;
  status: string;
  businessName: string;
  chatUser?: boolean;
  farmSiteId?: string;
  pondId?: number;
  businessTypeName: string;
  dialingCode: string;
  workLocation: string;
  reportingTo: any | string;
  level: number;
  pincode: string;
  reporting: string;
  employeeDesignation: string;
  employeeCode: string;
  providerBusinessPersons?: any;
  isDemo: boolean;
  isVerifying: number;
  otp: number;
  persons: any[];
  password: string;
  otpVerify: verifyOtp;

 constructor() {
    super();
    this.address = new Array();
    this.personType = new Array();
    this.farmLocations = new Array();
  }
}

//////////////////////////////
//IAddress
//////////////////////////////
export class IAddress {
  houseNo: string;
  street: string;
  landMark: string;
  city: string;
  state: string;
  district: string;
  pincode: string;
  country: string;
  latitude?: number;
  longitude?: number;
  village?: string;

  constructor() { }
}

//////////////////////////////
//IFarmLocations
//////////////////////////////
export class IFarmLocations {
  farmSiteID?: string;
  chatUser?: boolean;
  // _id?: string;

  constructor() { }
}

//////////////////////////////
//IFarmBusiness
//////////////////////////////
export class IFarmBusiness {
  businessID?: string;

  constructor() { }
}

//////////////////////////////
//IPersonType
//////////////////////////////
export class IPersonType {
  name: string;
  _id?: string;
  personRoleID: string;

  constructor() { }
}

export class addUserToAclObj{
  userName: string;
  password: string;
  role: string;
  businessID: string;
  personID: string
  isPasswordRested?: boolean;
}

export class sendPasswordToMobileEmailObj{
  mobileNumber: string;
  dialingCode: string;
  email: string;
  password: string;
  businessID: string;
  templateNameCode: string;
}

export class verifyOtp{
  mobileNumber: string;
  otp: string;
  event: string;
}
